// Section keys (one per editor / data file)
export type SectionKey =
  | 'whyChoose'
  | 'reviews'
  | 'parents'
  | 'news'
  | 'mealsWeek1'
  | 'mealsWeek2'
  | 'forms'
  | 'fees'
  | 'features'
  | 'about';

// db paths for each section's patch payload
export const CMS_DATA_PATH: Record<SectionKey, string> = {
  whyChoose: '/cms/whyChoose',
  reviews: '/cms/reviews',
  parents: '/cms/parents',
  news: '/cms/news',
  mealsWeek1: '/cms/meals/week1',
  mealsWeek2: '/cms/meals/week2',
  forms: '/cms/forms/contactFields',
  fees: '/cms/fees',
  features: '/cms/features',
  about: '/cms/about',
};

// versions & timestamps
export const CMS_VERSIONS_PATH = '/cms/_versions';
export const CMS_UPDATED_AT_PATH = '/cms/_updatedAt';

// cache config
export const CMS_CACHE_TTL_HOURS = 48; // fallback refresh every 48h
